import { ApiClient } from '../../ApiClient';
import {
  CreateCustomFieldDTO,
  CustomFieldDTO,
  UpdateCustomFieldDTO,
} from '../dto/CustomFieldDTO';

export class CustomFieldDataSource {
  constructor(private api: ApiClient) {}

  async getCustomFields(): Promise<CustomFieldDTO[]> {
    const response = await this.api.get<CustomFieldDTO[]>('/products/custom-fields');
    return response.data;
  }

  async createCustomField(data: CreateCustomFieldDTO): Promise<CustomFieldDTO> {
    const response = await this.api.post<CustomFieldDTO>('/products/custom-fields', data);
    return response.data;
  }

  async updateCustomField(
    customFieldId: string,
    data: UpdateCustomFieldDTO
  ): Promise<CustomFieldDTO> {
    const response = await this.api.put<CustomFieldDTO>(
      `/products/custom-fields/${customFieldId}`,
      data
    );
    return response.data;
  }

  async deleteCustomField(customFieldId: string): Promise<void> {
    await this.api.delete(`/products/custom-fields/${customFieldId}`);
  }
}
